import { jsx as _jsx } from "react/jsx-runtime";
import axios from "axios";
import * as React from "react";
import { createContext, useContext } from "react";
export var RestfulApiType;
(function(RestfulApiType) {
    RestfulApiType[RestfulApiType["AUTH"] = 0] = "AUTH";
    RestfulApiType[RestfulApiType["ALL"] = 1] = "ALL";
})(RestfulApiType || (RestfulApiType = {}));
export const FormSubmitRequest = [
    "/signin",
    "/signup/signup",
    "/signup/sendId",
    "/signup/checkUserId",
    "/signup/Vcccdeehko",
    "/signup/checkVcode",
    "/signup/sendTempPass",
    "/payment/requiredValue",
    "/more/changePassword",
    "/more/apiConnect",
    "/more/apiDisconnect",
    "/more/secession",
    "/more/subscriptionFee",
    "/rank/tradeHistory"
];
export class RestfulApiService {
    // getNavigationRef() {
    // 	return this.navigationRef
    // }
    async initialize() {
        this.client = axios.create();
        this.client.defaults.baseURL = this.getEndpoint(RestfulApiType.ALL);
        this.client.defaults.withCredentials = true;
        // this.client.defaults.headers.common['x-app-version'] = DeviceInfo.getVersion()
        // this.client.defaults.headers.common['x-app-platform'] = Platform.OS
        this.client.interceptors.request.use((config)=>{
            // log a message before any HTTP request is sent
            // console.log('request: ', config.url, config.params, config.data)
            return config;
        });
    }
    setAccessToken(accessToken, refreshToken) {
        ;
        if (!accessToken) {
            delete this.client.defaults.headers.common["Authorization"];
        // delete this.client.defaults.headers.common['x-access-token']
        } else {
            this.client.defaults.headers.common["Authorization"] = accessToken;
        // this.client.defaults.headers.common['x-access-token'] = accessToken
        }
    // if (!refreshToken) {
    // 	delete this.client.defaults.headers.common['x-refresh-token']
    // } else {
    // 	this.client.defaults.headers.common['x-refresh-token'] = refreshToken
    // }
    }
    getAccessToken() {
        var _this_client_defaults_headers_common_Authorization, _this_client_defaults_headers;
        return (_this_client_defaults_headers_common_Authorization = (_this_client_defaults_headers = this.client.defaults.headers) === null || _this_client_defaults_headers === void 0 ? void 0 : _this_client_defaults_headers.common["Authorization"]) === null || _this_client_defaults_headers_common_Authorization === void 0 ? void 0 : _this_client_defaults_headers_common_Authorization.toString();
    }
    getCommonHeader() {
        const { Accept , ...header } = this.client.defaults.headers.common;
        return header;
    }
    getClient() {
        return this.client;
    }
    setApiEndpoint(values) {
        this.endpoints = values;
    }
    getEndpoint(type) {
        const apiEndpoints = this.endpoints[RestfulApiType[type]];
        const currentIdx = this.loadBalanceTable[RestfulApiType[type]];
        const nextIdx = (currentIdx + 1) % apiEndpoints.length;
        this.loadBalanceTable[RestfulApiType[type]] = nextIdx;
        return apiEndpoints[currentIdx];
    }
    fetch(url) {
        let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return this.client({
            ...options,
            headers: {
                ...options.headers
            },
            url: url.toString(),
            params: options.params
        });
    }
    constructor(options = {
        maxRetry: 3
    }){
        // console.log('initialize restful api client')
        this.options = options;
        this.loadBalanceTable = {
            AUTH: 0,
            ALL: 0
        };
        this.initialize = this.initialize.bind(this);
        this.setAccessToken = this.setAccessToken.bind(this);
        this.getAccessToken = this.getAccessToken.bind(this);
        this.getClient = this.getClient.bind(this);
        this.setApiEndpoint = this.setApiEndpoint.bind(this);
        this.getEndpoint = this.getEndpoint.bind(this);
        this.fetch = this.fetch.bind(this);
    // this.refreshToken = this.refreshToken.bind(this)
    // this.navigationRef = null
    // this.authStore = null
    }
}
export const RestfulContext = /*#__PURE__*/ createContext(null);
export const RestfulApiProvider = (param)=>{
    let { value , children  } = param;
    return /*#__PURE__*/ _jsx(RestfulContext.Provider, {
        value: value,
        children: children
    });
};
export const useApiService = ()=>{
    const store = useContext(RestfulContext);
    if (!store) {
        // this is especially useful in TypeScript so you don't need to be checking for null all the time
        throw new Error("useStore must be used within a StoreProvider.");
    }
    return store;
};
export const isRestfulApiService = (value)=>{
    return value instanceof RestfulApiService;
};
